import React from 'react';
import { includes } from 'lodash/fp';
import RiskPickerListItem from './RiskPickerListItem';
import { FGStack, FGTypography } from '@fg/design-system';
import {
    RiskPickerAbstractContentProps,
    RiskPickerItem,
} from './RiskPicker';
import { mapWithKeys } from 'utils/lodashUtils';

type Props = RiskPickerAbstractContentProps & {
    items: RiskPickerItem[];
    multi?: boolean;
    onItemClick: (id: number) => void;
};

const RiskPickerList = React.memo((props: Props) => {
    return (
        <FGStack direction="column" gap={4}>
            {mapWithKeys((item: RiskPickerItem, index) => {
                const isSelected = includes(item.id, props.selectedItemsIds);
                return (
                    <React.Fragment key={item.id}>
                        {item.topDivider && (
                            <FGTypography
                                tag="label"
                                variant="body4"
                                cssStyle={{
                                    paddingBottom: 12,
                                    paddingTop: index === 0 ? 0 : 16,
                                }}>
                                {item.topDivider}
                            </FGTypography>
                        )}
                        <RiskPickerListItem
                            key={item.id}
                            item={item}
                            onClick={id => props.onItemClick(id)}
                            isMultiSelect={props.multi}
                            isSelected={isSelected}
                            riskStructure="list"
                        />
                    </React.Fragment>
                );
            }, props.items)}
        </FGStack>
    );
});

export default RiskPickerList;
